export const invoiceTypeDropDown = [
    {
        label: "Expense",
        value: "1"
    },
    {
        label: "Sales",
        value: "2"
    },
    {
        label: "Others",
        value: "3"
    },
  
]
export const transactionAmountTypeDropDown = [
    {
        label: "Credit",
        value: "credit"
    },
    {
        label: "Debit",
        value: "debit"
    },
  
]
export const transactionAmountLimitDropdown = [
    {
        label: "More than Value",
        value: "more_than_value"
    },
    {
        label: "Less than Value",
        value: "less_than_value"
    },
    {
        label: "Equal to Value",
        value: "equal_to_value"
    },
  
]